import React, { useState } from "react";
import { Lock } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

/* Who can open the Informe. Only admins see this; the list is saved on the server. */
export function AccessControl({ access, onChange }) {
  const [busy, setBusy] = useState(false);
  if (!access?.can_manage) return null;
  const toggle = async (email) => {
    const has = access.viewers.includes(email);
    const viewers = has ? access.viewers.filter((e) => e !== email) : [...access.viewers, email];
    if (!viewers.length) { toast.error("Debe quedar al menos una persona con acceso"); return; }
    setBusy(true);
    try { const { data } = await api.put("/kimkim/report/access", { viewers }); onChange(data); toast.success(has ? "Acceso retirado" : "Acceso concedido"); }
    catch (e) { toast.error(e?.response?.data?.detail ? String(e.response.data.detail) : "No se pudo guardar"); }
    finally { setBusy(false); }
  };
  return (
    <div className="flex flex-wrap items-center gap-1.5 text-[11px] text-clay-600" data-testid="kk-report-access">
      <Lock size={11}/> <span>Ven el informe:</span>
      {access.candidates.map((c) => {
        const on = access.viewers.includes(c.email);
        return (
          <button key={c.email} type="button" onClick={() => toggle(c.email)} disabled={busy} aria-pressed={on} title={c.email}
            data-testid={`kk-report-access-${c.email}`}
            className={`px-2 py-0.5 border ${on ? "border-clay-900 bg-clay-900 text-clay-50" : "border-clay-300 bg-white text-clay-600 hover:border-clay-900"} disabled:opacity-50`}>
            {c.name}
          </button>
        );
      })}
    </div>
  );
}
